import { Theme, css } from '@emotion/react';

export const menuItemCardStyles = () => css`
  height: 100%;
  width: 100%;
  border: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  padding: 0;
  &,
  &:last-child {
    padding: 0;
  }
`;

export const menuItemCardContentStyles = () => css`
  display: flex;
  width: 100%;
`;

export const menuItemNameStyles = () => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const menuItemRootStyles = ({ colors, spacing, breakpoints }: Theme) => css`
  width: 100%;
  &,
  &:last-child {
    padding-bottom: ${spacing(1)}px;
  }
  ${breakpoints.up('sm')} {
    &,
    &:last-child {
      padding-bottom: ${spacing(2)}px;
    }
  }
  & .MuiPaper-root {
    width: 100%;
    border: 0;
    border-top: 1px solid ${colors.borderDefault};
    border-bottom: 0;
  }
`;

export const menuItemModifierGroupsStyles = ({ spacing }: Theme) => css`
  display: block;
  margin-top: ${spacing(2)}px;
`;

export const menuItemContentStyles = ({ spacing, breakpoints }: Theme) => css`
  width: 100%;
  display: block;
  padding-top: ${spacing(1)}px;
  padding-right: ${spacing(1)}px;
  ${breakpoints.up('sm')} {
    padding-top: ${spacing(1.5)}px;
    padding-right: ${spacing(1.5)}px;
  }
`;

export const menuItemContentWithImageStyles = ({ spacing, breakpoints }: Theme) => css`
  width: calc(100% - 60px);
  display: block;
  padding-top: ${spacing(1)}px;
  padding-right: ${spacing(1)}px;
  ${breakpoints.up('sm')} {
    width: calc(100% - 60px);
    padding-top: ${spacing(1.5)}px;
    padding-right: ${spacing(1.5)}px;
  }
`;

export const menuItemImageStyles = ({ spacing, breakpoints, borderRadius }: Theme) => css`
  border-radius: ${borderRadius[100]};
  width: 60px;
  height: 60px;
  margin-top: ${spacing(1)}px;
  ${breakpoints.up('sm')} {
    margin-top: ${spacing(1.5)}px;
  }
`;

export const menuItemModifierItemGroupStyles = ({ spacing }: Theme) => css`
  margin-top: ${spacing(0.5)}px;
  padding-bottom: ${spacing(0.5)}px;
`;
